import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 14, interactive = false, onChange }) {
  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={!interactive}
          data-testid={interactive ? `star-${i}` : undefined}
          onClick={interactive ? () => onChange(i) : undefined}
          className={interactive ? "cursor-pointer transition-transform duration-200 hover:scale-125" : "cursor-default"}
        >
          <Star
            size={size}
            className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}
          />
        </button>
      ))}
    </div>
  );
}
